<template lang="pug">
  .container
    .py-3
      #logo-slider-wrap.position-relative
        VueSlickCarousel(
          :arrows="false",
          :dots="false",
          :infinite="true",
          :slidesToShow="9",
          :autoplay="true",
          :speed="speed",
          :autoplaySpeed="speed",
          cssEase="linear"
          :responsive="responsive"
          :pauseOnHover="false"
        )
          .brand-logo.col-10.col-xl-11.p-0(v-for="imageUrl in imageUrls")
            img.img-fluid(:src="imageUrl")
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  name: "LogoCarousel",
  components: {
    VueSlickCarousel,
  },
  data() {
    return {
      speed: 2250,
      imageUrls: [
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/achat.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/akzent.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/ao.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/azimut.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/center-hotels.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/Couryard-by-Marriott.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/dorint.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/dormero.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/gch.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/goebel_logo.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/hilton.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/holidayinn.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/hs-hotels.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/ibis.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/kempinski.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/kommerzhotel.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/luckylogie.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/mercure.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/michel-hotel.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/mk-hotels.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/nh-hotels.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/orange-hotels.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/parkinn.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/plaza-hotelgroup.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/precise-hotels.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/prima-hotels.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/radisson-blue.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/ramada.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/ringhotels.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/savoy.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/select.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/sheraton.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/titanic.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/tryp-by-wyndham.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/tulip-inn.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/upstalsboom.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/vienna-house.jpg",
        "https://s3-cloud.td-cdn.de/Images/makaira/logo-slider/update-q1-2022/wyndham-hotel-group.jpg",
      ],
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 9,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 7,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 5,
          },
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/_colors.scss";
#logo-slider-wrap {
  .brand-logo {
    position: relative;
    left: 50%;
    transform: translate(-50%, 0%);
    border: 2px solid $td-grey-lighter;
    --border-radius: 10px;
    border-bottom-left-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);

    img {
      border-bottom-left-radius: var(--border-radius);
      border-bottom-right-radius: var(--border-radius);
    }
  }
}
</style>
